import { styled } from 'styled-components';
import { theme } from '../styles';
import { motion } from 'framer-motion';
import Footer from './Footer';

const NoRenderFooter = <Footer />;

const SideNav = ({ items, active, handleSelect }) => {
  return (
    <Aside>
      <Items>
        {Object.keys(items).map((item, ind) => (
          <NavItem
            key={`aside-item-${ind}`}
            type='button'
            onClick={() => handleSelect(item)}
            $active={item === active}
            initial={theme.fadeIn.initial}
            animate={theme.fadeIn.animate}
            transition={theme.fadeIn.transition(theme.delaySm + 0.1 * ind)}
          >
            {items[item].element}
          </NavItem>
        ))}
      </Items>
      {NoRenderFooter}
    </Aside>
  );
};

const Aside = styled.aside`
  height: calc(
    100vh - (2 * ${props => props.theme.spaceLg}) - var(--nav-height) -
      ${props => props.theme.spaceLg}
  );
  min-height: calc(
    100vh - (2 * ${props => props.theme.spaceLg}) - var(--nav-height) -
      ${props => props.theme.spaceLg}
  );
  width: var(--sidenav-width);
  min-width: var(--sidenav-width);
  padding-top: ${props => props.theme.spaceMd};
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  footer {
    flex-direction: column;
    gap: ${props => props.theme.spaceMd};
  }

  @media only screen and (min-width: ${props => props.theme.breakpoints.width.lg}) {
    footer {
      width: 100%;
      flex-direction: row;
      justify-content: space-between;
      gap: ${props => props.theme.spaceSm};
    }
  }
`;

const Items = styled.nav`
  display: flex;
  flex-direction: column;
`;

const NavItem = styled(motion.button)`
  padding: ${props => props.theme.spaceMd} 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${props => props.theme.spaceMd};

  color: ${props => (props.$active ? props.theme.brand : props.theme.mutedColor)};
  font-weight: 400;
  text-align: left;
  background: transparent;
  border: none;

  cursor: pointer;
  transition: color 0.125s ease-in-out, border-color 0.125s ease-in-out;

  &:hover {
    color: ${props => props.theme.textColor};
  }

  svg {
    height: ${props => props.theme.sizeH4};
    width: ${props => props.theme.sizeH4};
    min-height: ${props => props.theme.sizeH4};
    min-width: ${props => props.theme.sizeH4};
  }

  @media only screen and (min-width: ${props => props.theme.breakpoints.width.lg}) {
    justify-content: start;
    font-size: ${props => props.theme.sizeBody};
  }

  @media only screen and (min-width: ${props => props.theme.breakpoints.width.xl}) {
    font-size: ${props => props.theme.sizeH6};
  }
`;

export const NavText = styled.span`
  display: none;
  @media only screen and (min-width: ${props => props.theme.breakpoints.width.lg}) {
    display: inline-block;
  }
`;

export default SideNav;
